export default {
    "en": {
        "nova-fields": {
            "first_name": "First name",
            "last_name": "Last name",
            "email": "Email",
            "password": "Password",
            "signup_ip": "Signup IP",
            "username": "Username",
            "created_at": "Created",
            "updated_at": "Updated",
            "name": "Name",
            "status": "Status",
            "type": "Type",
            "experiment": "Experiment",
            "ai_assist": "Show Robot advice",
            "show_feedback": "Show feedback",
            "selection_matrix": "Selection matrix",
            "meta_data": "Meta",
            "target_number_of_presentations": "Target number of prsentations",
            "stage": "Stage|Stages",
            "user": "User|Users",
            "origin": "Origin",
            "answer": "Answer",
            "robot_answer": "Robot answer",
            "guard_name": "Guard name",
            "role": "Role|Roles",
            "permission": "Permission|Permissions",
            "consent_terms": "Consent terms",
            "group": "Group|Groups",
            "true_positive_rate": "True positive rate",
            "true_negative_rate": "True negative rate",
            "order": "Order",
            "condition": "Condition|Conditions",
            "algorithm": "Robot algorithm",
            "robot": "Robot|Robots",
            "description": "Description|Descriptions",
            "emails_batch": "Emails batch",
            "option": "Option|Options",
            "dataset": "Dataset|Datasets",
            "response_option": "Response option|Response options",
            "artifact": "Artifact|Artifacts",
            "url": "URL",
            "parent": "Parent|Parents",
            "child": "Child|Children",
            "format": "Format",
            "properties": "Properties",
            "reference_answer": "Reference answer",
            "crowd_answer": "Crowd answer",
            "crowd_confidence": "Crowd condidence",
            "state": "State|States",
            "artifact_dataset": "Artifact Dataset|Artifact Datasets",
            "robot_algorithm": "Robot algorithm",
            "seconds_to_respond": "Seconds to respond",
            "title": "Title",
            "content": "Content",
            "slug": "Slug",
            "contentable": "Content for",
            "poster": "Artifact poster image",
            "popup_title": "Popup Title",
            "popup_text": "Popup Text",
            "popup_icon": "Popup Icon",
            "survey_type": "Survey type",
            "typeform_url": "Typeform url",
            "minutes_to_respond": "Minutes user has to repond",
            "minutes_to_resume": "Minutes user has to resume",
            "enable_next_button": "Enable next button",
            "ai_configuration": "AI Configurations",
            "stage_details": "Stage details",
            "pop_up_and_surveys": "Pop-up & Survey",
            "num_rows": "N",
            "std_accuracy": "std(ACC)",
            "positive_predictive_value": "PPV",
            "std_positive_predictive_value": "std(PPV)",
            "true_positive_rate_summary_stats": "TPR",
            "std_true_positive_rate": "std(TPR)",
            "true_negative_rate_summary_stats": "TNR",
            "std_true_negative_rate": "std(TNR)",
            "balanced_accuracy": "BA",
            "std_balanced_accuracy": "std(BA)",
            "accuracy": "ACC",
            "scoring_rubic_type": "Scoring",
            "is_calibration": "Is Calibration",
            "scoring_weight_matrix": "Scoring weight matrix",
            "factor": "Factor",
            "started_at": "From",
            "completed_at": "To",
            "is_active": "Is active ?",
            "number_of_options": "Number of options",
            "difficulty": "Difficulty",
            "is_default": "Is Default",
            "domain": "Domain|Domains",
            "tenant": "Tenant|Tenants",
            "always_running": "Always running",
            "dedicated_to": "Dedicated to",
            "guardian_email": "Guardian email",
            "has_consent_been_given": "Consent given",
            "is_completed": "Completed",
            "is_quit": "Quit",
            "pre_survey_started": "Pre-survey started",
            "pre_survey_completed": "Pre-survey completed",
            "post_survey_started": "Post-survey started",
            "post_survey_completed": "Post-survey completed",
            "is_researcher": "Is researcher",
            "score": "Score",
            "sensitivity": "Sensitivity",
            "scoring_weighted_average": "Scoring weighted average",
            "path": "Path",
            "is_landing_page": "Is landing page ?",
            "style": "Styles",
            "script": "script",
            "code": "Code",
            "page_title": "Page title",
            "head": "Head",
            "allow_signup": "Allow signup",
            "allow_multiple_experiments": "Allow Multiple Experiments",
            "mail_from": "Mail from address",
            "mail_signature": "Mail signature",
            "minors_need_consent": "Minors need consent ?",
            "favicon_url": "Favicon URL",
            "nav_logo_url": "Navbar Logo URL",
            "tutorial_url": "Tutorial URL",
            "add_artifact_to_dataset": "Create artifact",
            "batch_upload_artifacts": "Upload artifacts in batch",
            "artifacts_batch_file": "Artifacts batch file",
            "force_download": "Force download",
            "stage_started": "Stage started"
        },
        "enums": {
            "Hcinst\\CatchersCore\\Enums\\ExperimentStatus": {
                "1": "Active",
                "0": "Inactive"
            },
            "Hcinst\\CatchersCore\\Enums\\StageType": {
                "1": "Artifacts presentation",
                "2": "TypeForm",
                "3": "Static text",
                "4": "Pop-up"
            },
            "Hcinst\\CatchersCore\\Enums\\GroupType": {
                "1": "Research Team",
                "2": "Competitive Team"
            },
            "Hcinst\\CatchersCore\\Enums\\SurveyType": {
                "post_survey": "Post experiment survey",
                "pre_survey": "Pre experiment survey"
            },
            "Hcinst\\CatchersCore\\Enums\\SurveyOrigin": {
                "typeform": "Typeform",
                "internal": "Internal"
            },
            "Hcinst\\CatchersCore\\Enums\\Role": {
                "super_admin": "Super Admin",
                "admin": "Admin",
                "researcher": "Researcher",
                "player": "Player",
                "curator": "Curator"
            },
            "Hcinst\\CatchersCore\\Enums\\Permission": {
                "access_bo": "Access Back-Office",
                "research": "Research",
                "play": "Play",
                "review_artifact": "Review artifact"
            },
            "Hcinst\\CatchersCore\\Enums\\RobotAlgorithm": {
                "bernoulli_trials": "Bernoulli Trials",
                "pre_shuffling": "Pre-shuffling"
            },
            "Hcinst\\CatchersCore\\Enums\\ArtifactFormat": {
                "1": "mp4",
                "2": "jpg",
                "3": "png"
            },
            "Hcinst\\CatchersCore\\Enums\\ArtifactType": {
                "2": "Image",
                "1": "Video"
            },
            "Hcinst\\CatchersCore\\Enums\\ArtifactStatus": {
                "1": "Active"
            },
            "Hcinst\\CatchersCore\\Enums\\RobotType": {
                "1": "Talking",
                "2": "Pointing"
            },
            "Hcinst\\CatchersScoring\\Enums\\ScoringRubric": {
                "1": "Boolean",
                "2": "Boolean with options"
            },
            "Hcinst\\CatchersScoring\\Enums\\ReviewStatus": {
                "1": "Approved",
                "2": "Rejected"
            }
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "ends_with": "The {attribute} must end with one of the following: {values}",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "password": "The password is incorrect.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "uuid": "The {attribute} must be a valid UUID.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "passwords": {
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address.",
            "throttled": "Please wait before retrying."
        },
        "messages": {
            "login": "Login",
            "logout": "Logout",
            "toggle_navigation": "Toggle navigation",
            "settings": "Settings",
            "register": "Register",
            "forgot_your_password": "Forgot Your Password ?",
            "email": "Email",
            "password": "Password",
            "remember_me": "Remember me",
            "confirm_password": "Confirm Password",
            "first_name": "First Name",
            "last_name": "Last Name",
            "username": "Username",
            "reset_password": "Reset password",
            "send_password_reset_link": "Send Password Reset Link",
            "about": "About",
            "terms_and_privacy": "Terms & Privacy",
            "how_to": "How to",
            "tutorial": "Tutorial",
            "experiment": "Experiment|Experiments",
            "overview": "Overview",
            "instruction": "Instruction|Instructions",
            "consent": "Consent",
            "quit_early": "Quit early",
            "loading": "Loading",
            "not_found": "Not Found",
            "forbidden": "Forbidden",
            "next": "Next",
            "artifact_loaded": "ArtifactDataset {id} loaded",
            "stage_started": "Stage started",
            "welcome_to_stage": "Welcome to {name}",
            "respond_to_each_artifact": "Use your best judgement to select the correct answer on each artifact",
            "next_stage": "Next stage",
            "start_survey": "Start survey !",
            "post_experiment_survey_started": "Post experiment survey started !",
            "post_experiment_survey_completed": "Post experiment survey completed !",
            "well_done": "Well done !",
            "experiment_completed": "Congratulations you completed the experiment {experiment}!",
            "experiment_completed_footer": "You will get new experiment notifications when a new experiment is available.",
            "pre_experiment_survey_started": "Pre experiment survey started !",
            "pre_experiment_survey_completed": "Pre experiment survey completed !",
            "robot_advice": "I think the answer is <strong>{answer}</strong>",
            "thinking": "Thinking",
            "robot_boolean_feedback_correct": "Exactly right! You matched <strong>{answer}</strong>",
            "robot_boolean_feedback_incorrect": "Incorrect - The answer is <strong>{answer}!</strong>",
            "robot_boolean_feedback_almost": "You matched <strong>{answer}</strong>",
            "robot_boolean_feedback_correct_with_points": "Exactly right! You matched <strong>{answer}</strong> and got {points} points.",
            "robot_boolean_feedback_almost_with_points": "You matched <strong>{answer}</strong>, and got {points} points",
            "feedback_generic": "Answer saved! Click Next to continue",
            "feedback_generic_with_points": "<strong>{points} points!</strong> Redeem later...",
            "group": "Group|Groups",
            "stage": "Stage|Stages",
            "user": "User|Users",
            "your_experiment_not_found": "We couldn't find any experiment you've registered for. Please contact the support team",
            "current_experiment": "Current ongoing experiment",
            "survey_response": "Survey response|Survey responses",
            "role": "Role|Roles",
            "permission": "Permission|Permissions",
            "send_invitation": "Send invitations",
            "experiment_registration": "Experiment registration",
            "experiment_registration_email_text": "You've been invited to participate in {experiment} on Civium. Click the button below to register",
            "invitations_sent": "Invitations have been queued and on their way !",
            "invite_to_experiment": "Invite to participate in {experiment}",
            "unsubscribed_from_experiment": "You have to agree to participate in {experiment}",
            "user_has_been_unsubscribed_from_experiment": "{user} is not allowed to participate in {experiment}.",
            "your_choice_has_been_recorded": "Your choice has been recorded.",
            "already_subscribed_to_experiment": "{user} has already joined {experiment}",
            "join_experiment": "Join the {experiment} experiment",
            "user_has_been_added_to_experiment": "{user} is now a participant in {experiment}",
            "review_experiment_terms": "To approve the participation of {user} in {experiment}, please review and agree to the following terms",
            "review_experiment_your_terms": "To approve your participation in {experiment}, please review and agree to the following terms",
            "agree_to_participate": "I agree to participate",
            "dont_agree_to_participate": "I do not agree to participate",
            "begin_experiment": "Begin!",
            "login_begin_experiment": "Login & begin!",
            "condition": "Condition|Conditions",
            "date_of_birth": "Date of birth",
            "year": "Year|Years",
            "month": "Month|Months",
            "day": "Day|Days",
            "year_of_birth": "Year of birth",
            "month_of_birth": "Month of birth",
            "day_of_birth": "Day of birth",
            "parental_consent_given_by": "Parental consent given by (enter email only)",
            "guardian_email": "Guardian Email",
            "approve_participation_to_experiment_for_user": "Please approve the participation of {user} in {experiment} on Civium",
            "experiment_guardian_consent": "Experiment parental consent",
            "experiment_guardian_consent_email_text": "{user} asked for your consent to participate in the experiment {experiment} on Civium. Please click the link below to review the experiment consent terms.",
            "give_consent": "Review",
            "accept_terms": "Accept terms",
            "refuse_terms": "Refuse terms",
            "send_response": "Send response",
            "waiting_for_guardian_consent": "Waiting for guardian consent",
            "waiting_for_guardian_consent_text": "We've sent your parent an email asking permission for you to participate. If they approve, you will receive an email with a link that allows you to participate in the experiment.",
            "waiting_for_guardian_consent_footer": "Once they have approved, you can also just click \"Try again\" below and get started right away.",
            "try_again": "Try again",
            "experiment_consent_approved": "Consent given for participation in {experiment}",
            "experiment_guardian_approved_consent": "Your guardian has approved your participation",
            "experiment_guardian_approved_consent_email_text": "Congratulations, your guardian has given consent for your participation in {experiment}. Click the \"Begin!\" button to start the experiment.",
            "experiment_guardian_approved_consent_email_ps": "If you logged out, a link to set your password was sent in a separate email.",
            "experiment_consent_denied": "Consent denied for participation in {experiment}",
            "experiment_guardian_refused_consent": "Your guardian has refused your participation",
            "experiment_guardian_refused_consent_email_text": "Unfortunately, your guardian has denied your entry to {experiment} and as such you won't be able to participate in this experiment. We hope to see you again!",
            "robot": "Robot|Robots",
            "sincerely": "Sincerely",
            "play_stallcatchers_instead": "Play regular Stall Catchers instead?",
            "save": "Save",
            "you_are_not_approved_to_participate": "You are not approved to participate in this experiment.",
            "home": "Home",
            "set_password": "Set password",
            "password_has_been_set": "Your password has been saved and your email verified.",
            "link_expired": "The link has expired",
            "given_link_expired": "The link you've clicked on has expired or is no longer valid. Contact our team for further information: <a class=\"text-blue-500\" href=\"mailto:{email}\">{email}</a>.",
            "artifact": "Artifact|Artifacts",
            "dataset": "Dataset|Datasets",
            "response_option": "Response option|Response options",
            "reference_answer": "Reference answer",
            "experiment_registration_sub_info": "By signing up for the experiment, you are also agreeing to the <a target=\"_blank\" class=\"text-blue-500\" href=\"{url}\">Terms & Conditions</a> of this website. An account on Civium - a research accelerator developed by the Human Computation Institute - will automatically be created for you.",
            "experiment_invite_link_unauthorized": "You are not allowed to access this invitation link.",
            "looks_you_have_registered_already": "Looks like you're already registered for Civium, {user}! Please enter your password below.",
            "back_office": "Back office",
            "response": "Response|Responses",
            "cancel": "Cancel",
            "experiment_quit_message": "You have quit the experiment early either because you stopped for more than {minutes} minutes or because you intentionally quit. Thank you for participating!",
            "window_has_timeout": "Timeout warning",
            "window_has_timeout_description": "It looks like you might be taking a break.  For the research to be valid you need to continue participating within <b></b>, otherwise you will be automatically removed from the experiment.",
            "resume_experiment": "Resume experiment",
            "content": "Content|Contents",
            "are_you_sure": "Are you sure?",
            "quit_early_warning": "If you leave now, you will not be able to come back later and finish the experiment.",
            "quit_early_warning_logout": "If you log out now, you will quit the experiment early and not be able to return to it later. Are you you want to do this?",
            "yes": "Yes",
            "no": "No",
            "experiment_registrations": "Experiment registrations",
            "responses_on_artifacts": "Responses on artifacts",
            "presented_artifacts": "Presented artifacts",
            "frame": "Frame",
            "leader_board": "Leaderboard|Leaderboards",
            "my_team": "My Team",
            "my_score": "My Score",
            "experiment_stats": "Stats",
            "no_experiment_found": "No Experiment found",
            "total_research_time": "Total research time",
            "current_research_speed": "Current research speed",
            "current_dataset": "Current dataset",
            "current_challenge": "Current challenge",
            "my_performance": "My Performance",
            "catcher": "Catcher|Catchers",
            "my_team_is": "<strong>My team is</strong>: {group}",
            "catching_for": "<strong>I'm catching for</strong>: {dedicated}",
            "score": "Score|Scores",
            "level": "Level|Levels",
            "rank": "Rank|Ranks",
            "positive": "Positive|Positives",
            "lab_time": "Lab time",
            "redeem_your_points": "Redeem your points !",
            "edit_my_profile": "Edit my profile",
            "mode_title_labeling": "Labeling",
            "mode_title_curating": "Curating",
            "mode_title_uploading": "Uploading",
            "mode_title_browsing": "Browsing My Artifacts",
            "mode_title_referencing": "Reference Labels",
            "no_artifact_to_currate": "No artifacts to curate found !",
            "approve_artifact": "Release",
            "reject_artifact": "Reject",
            "inappropriate": "Inappropriate",
            "personally_identifiable_information": "Personally identifiable information",
            "not_relevant": "Not relevant",
            "other": "Other",
            "curation_completed": "Curation completed !",
            "no_artifacts_uploaded": "You have not uploaded any artifacts yet !",
            "previous": "Previous",
            "click_to_edit_artifact": "Click on the artifacts to position blurring.",
            "tenant": "Tenant|Tenants",
            "domain": "Domain|Domains",
            "whoops": "Whoops!...",
            "no_artifacts_found": "We could not find any artifacts.",
            "artifact_uploaded": "Artifact uploaded",
            "order_by": "Order by",
            "created_at": "Created",
            "updated_at": "Updated",
            "profile": "Profile|Profiles",
            "activity": "Activity|Activities",
            "upload": "Upload",
            "page": "Page|Pages",
            "sign_up": "Sign up",
            "no_points_to_redeem": "No points to redeem yet... Check back!",
            "pending": "pending",
            "redeemed": "redeemed",
            "good_job": "Good job!",
            "you_have_redeem_points": "You've redeemed <strong>{points}</strong> points!",
            "set_password_email_sent": "An email to set your password has been sent to your inbox!",
            "leaderboard_mode_catchers_label": "Catchers",
            "leaderboard_mode_my_team_label": "My team",
            "leaderboard_mode_all_team_label": "All teams",
            "leaderboard_range_today_label": "Today",
            "leaderboard_range_this_week_label": "This week",
            "leaderboard_range_all_time_label": "All time",
            "no_data_available": "No data available!",
            "my_gallery": "My gallery",
            "leave_feedback": "Leave feedback",
            "an_error_occurred": "An error occured during request. Try again later",
            "artifact_rejected": "Your uploaded artifact failed curation guidelines",
            "your_uploaded_artifact_was_rejected": "The artifact {artifact} you've uploaded was failed the following curating guidelines:",
            "something_went_wrong": "Oh no! Something needs your attention.",
            "drag_and_drop_artifact_image": "Drag and drop your artifact image",
            "attention": "Attention!",
            "pending_uploads": "Pending uploads",
            "approved_uploads": "Approved uploads",
            "curator_guidelines": "Curator's Guidelines",
            "get_started": "Get started",
            "dataset_not_found": "Dataset not found",
            "artifacts_batch_uploaded": "Batch artifacts uploaded!",
            "how_to_curator": "How to:",
            "comment": "Comment|Comments",
            "be_the_first_to_comment": "Be the first to comment.",
            "type_your_message_here": "Type your message here...",
            "send": "Send",
            "comments_will_be_visible_after_response": "Comments will be visible after an answer is given.",
            "online": "Online",
            "online_catchers": "{number} Catcher|{number} Catchers",
            "confirm_your_age": "Confirm your age",
            "confirm_your_age_to_upload": "To be considered for uploading you must enter a date of birth here. Then try again.",
            "confirm_your_age_to_currate": "To be considered for curating you must enter a date of birth here. Then try again.",
            "back": "Back",
            "not_allowed_upload_as_minor": "You must be at least 18 years old to upload artifacts. If you believe there is a mistake about your age, please click <a class=\"underline text-blue-500\" href=\"mailto:info@dreamcatchers.app\">here</a> to email us at info@dreamcatchers.app",
            "not_allowed_curate_as_minor": "You must be at least 18 years old to be considered as a curator. If you believe there is a mistake about your age, please click <a class=\"underline text-blue-500\" href=\"mailto:info@dreamcatchers.app\">here</a> to email us at info@dreamcatchers.app",
            "not_allowed_curate_without_permission": "If you wish to curate artifacts on Dream Catchers, please click <a class=\"underline text-blue-500\" href=\"mailto:info@dreamcatchers.app?subject=Curator request\">here</a> to send an email to info@dreamcatchers.app. If you meet the criteria for being a curator, you will be given access to the curation feature. You will be notified either way. Curator requirements are listed <a class=\"underline text-blue-500\" href=\"/pages/curators-guidelines\" target=\"_blank\">here</a>",
            "my_profile": "My profile",
            "what_do_you_see": "What do you see?",
            "not_allowed_to_signup_as_minor": "You must be at least 18 years old to signup for dreamcatchers.",
            "not_allowed_to_signup_as_non_us_resident": "You must reside in the United States to sign up for dreamcatchers.",
            "i_am_at_least_18": "I am at least 18 years old",
            "i_reside_in_us": "I reside in the United States",
            "account_has_been_banned": "Your account has been banned by the admin.If you believe there is a mistake about you being banned, please click <a class=\"underline text-blue-500\" href=\"mailto:info@dreamcatchers.app?subject=Request Access\">here</a> to send an email to info@dreamcatchers.app.",
            "ban": "Ban",
            "mode": "Mode",
            "consent_form": "Consent Form|Consent Forms",
            "consent_submitted": "Consent for this form has been submitted",
            "accept": "Accept",
            "refuse": "Refuse",
            "need_to_accept_form": "You need to accept the consent form {title} before proceeding to {mode} mode.",
            "consent_form_user": "Consent Form User|Consent Form Users",
            "form_title": "Form Title",
            "upload_consent_for_guardian": "By uploading this image you agree that you are a legal guardian of any children shown and there are no children over the age of 12 months",
            "expert_answers_in_bold_blue": "Experts answers in <span class=\"text-bold-blue font-weight-bolder\">bold/blue</span>"
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        }
    }
}
